module.exports = __webpack_public_path__ + "static/img/render1-thumb.109689a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/gallery/render1-thumb.jpg
// module id = 9j38
// module chunks = 0